/* lua.js generated code 0.3.0 */

LoginingAnim = xClass("LoginingAnim", cc.Node)
LoginingAnim.prototype.ctor = function (str, fontName = "font/zzgftongxin_70_greenstroke.fnt", useBMFont = true) {
    let self = this
    cc.Node.prototype.ctor(self);
    self.labels = table()
    self.isPlaying = false
    self.fontName = fontName
    self.useBMFont = useBMFont
    self.container = cc.Node.create()
    self.addChild(self.container)
    self.changeStr(str)
}
LoginingAnim.prototype.changeStr = function (str) {
    let self = this
    if (!str || str === "" || self.lastStr === str) {
        return 
    }
    let size = 0
    let sizeh = null
    self.labels = table()
    self.lastStr = str
    self.container.removeAllChildren(true)
    let items = str.split("")
    for (let index = 0; index < items.length; index++) {
        let label = null
        if (self.useBMFont) {
            label = cc.Label.createWithBMFont(self.fontName, items[index])
        }else {
            label = cc.Label.create(items[index], self.fontName, 23)
        }
        label.setAnchorPoint(0, 0)
        label.setPositionX(size)
        self.container.addChild(label)
        size = size + label.getContentSize().width
        table.insert(self.labels, label)
        if (!sizeh) {
            sizeh = label.getContentSize().height
        }
    }
    self.container.setPosition(-size / 2, -sizeh / 2)
    if (self.isPlaying) {
        self.play()
    }
    self.setContentSize(size, sizeh)
}
LoginingAnim.prototype.normal = function () {
    let self = this
    self.isPlaying = false
    for (let k = 1, v = self.labels[1]; v; k++, v = self.labels[k]) {
        v.stopAllActions()
        v.setPositionY(0)
    }
}
LoginingAnim.prototype.play = function () {
    let self = this
    self.normal()
    self.isPlaying = true
    for (let k = 1, v = self.labels[1]; v; k++, v = self.labels[k]) {
        let actionList = table()
        table.insert(actionList, cc.DelayTime.create(5 / 30 + (k - 1) * 2 / 30))
        table.insert(actionList, cc.MoveBy.create(5 / 30, cc.p(0, -13)))
        table.insert(actionList, cc.MoveBy.create(6 / 30, cc.p(0, 22)))
        table.insert(actionList, cc.MoveBy.create(5 / 30, cc.p(0, -9)))
        table.insert(actionList, cc.DelayTime.create(23 / 30 - (k - 1) * 2 / 30))
        v.runAction(cc.RepeatForever.create(cc.Sequence.create(actionList)))
    }
}